import { dataProps } from './properties'

export const setDiscountCouponList = (state, payload) => {
    state.list = payload
}

export const setDiscountCouponData = (state, payload) => {
    state.props = payload.response
}

export const resetDiscountCouponData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/discountCoupon/mutations.js